import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { confirmReceiptApi } from './confirmReceipt.api'
import confirmReceiptInitialState from './confirmReceipt.initialState'
import { ConfirmReceiptErrorResponse, ConfirmReceiptRequestPayload } from './confirmReceipt.types'

export const confirmReceipt = createAsyncThunk(
  urls.logisticsPartner.confirmReceipt,
  async (payload: ConfirmReceiptRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload || {}

    try {
      const response = await confirmReceiptApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const confirmReceiptSlice = createSlice({
  name: urls.logisticsPartner.confirmReceipt,
  initialState: confirmReceiptInitialState,
  reducers: {
    resetConfirmReceipt: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(confirmReceipt.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(confirmReceipt.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(confirmReceipt.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as ConfirmReceiptErrorResponse
        state.success = null
      })
  }
})

export const { actions: confirmReceiptActions, reducer: confirmReceiptReducer } = confirmReceiptSlice
export const { resetConfirmReceipt } = confirmReceiptActions
export default confirmReceiptSlice.reducer
